import {validate} from '../../../lib/schema-validator.js'
import {valueSchema, answerSchema} from './schema.js'

export const DATA_POINT_ID = 'has_facility_trained_workers_use_fire_fighting_equipment'

export const dataPointDefinition = {
  retracedId: 'has_facility_trained_workers_use_fire_fighting_equipment',
  name: 'Has the facility trained workers to use fire-fighting equipment in line with legal requirements?',
  description: 'Consult applicable legal requirements. ',
  meta: {
    slcpMeta: {
      key: 'hs-20--6',
      number: 'HS-EME-11',
      masterType: 'Question',
      versionImported: '1.7.0',
    },
  },
  fieldTypeId: 'SHORT_TEXT',
  type: 'RELATIONAL',
  options: [],
  schema: {
    type: 'object',
    properties: {
      value: {
        type: 'string',
      },
    },
    required: ['value'],
  },
  externalIds: [{id: 'hs-20--6', version: '1.7.0', provider: 'slcp'}],
  sortingId: 29240,
  sectionId: '',
  impactArea: '',
  impactAreaId: '',
}

export const validateSchema = data => {
  try {
    validate({value: data, schema: valueSchema})
    return data
  } catch (error) {
    throw new Error(`DATA_POINT_ID: ${error}`)
  }
}
export const transformAnswer = (answer, {meta}) => {
  try {
    validate({value: answer, schema: answerSchema})
    const formattedDataPointKey = DATA_POINT_ID.replace(/_([a-z])/g, g => g[1].toUpperCase())
    return {[formattedDataPointKey]: answer}
  } catch (error) {
    throw new Error(`DATA_POINT_ID: ${error}`)
  }
}
